import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-number-three-icon',
  templateUrl: './number-three-icon.component.html',
  styles: []
})
export class NumberThreeIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
